"use client";
import * as React from "react";

function Footer() {
  return (
    <footer className="box-border flex flex-col gap-2.5 justify-center items-center p-16 w-full min-h-[401px] max-md:px-8 max-md:py-12 max-sm:px-4 max-sm:py-8 bg-[#2a2540]">
      <div className="flex flex-col gap-10 justify-center items-center w-full max-w-[1200px] max-md:gap-8 max-sm:gap-6">
        {/* Logo Section */}
        <div className="flex relative items-center h-16 w-[163px]">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/f0c271811bbf72e4fd400d4c75dfc4fd20ca6e51"
            alt=""
            className="absolute top-0 left-0 shrink-0 h-16 aspect-[25/32] w-[50px]"
          />
          <div className="absolute shrink-0 h-[51px] left-[57px] top-[13px] w-[106px]">
            <h1 className="absolute top-0 left-0 text-2xl font-bold leading-6 text-white uppercase h-[26px] w-[61px]">
              Baby
            </h1>
            <h2 className="absolute left-0 text-2xl font-bold leading-6 text-white uppercase h-[26px] top-[25px] w-[106px]">
              Unicorn
            </h2>
          </div>
        </div>

        {/* Navigation Links */}
        {/* Desktop */}
        <nav className="hidden sm:flex flex-wrap justify-center items-center gap-8 max-md:gap-6">
             <a href="https://babyu-sale.tech/" className="text-base text-white hover:opacity-80">Presale</a>
          <a href="#features" className="text-xl text-white hover:opacity-80 max-md:text-lg">Features</a>
          <a href="#tokenomics" className="text-xl text-white hover:opacity-80 max-md:text-lg">Tokenomics</a>
          <a href="#roadmap" className="text-xl text-white hover:opacity-80 max-md:text-lg">Roadmap</a>
          <a href="#faq" className="text-xl text-white hover:opacity-80 max-md:text-lg">FAQ</a>
          <a href="#contact-us" className="text-xl text-white hover:opacity-80 max-md:text-lg">Contact Us</a>
        </nav>

        {/* Mobile: 3x3 grid centered */}
        <nav className="grid grid-cols-3 gap-4 justify-items-center text-center sm:hidden">
          <a href="https://babyu-sale.tech/" className="text-base text-white hover:opacity-80">Presale</a>
          <a href="#roadmap" className="text-base text-white hover:opacity-80">Roadmap</a>
          <a href="#faq" className="text-base text-white hover:opacity-80">FAQ</a>
          <a href="#features" className="text-base text-white hover:opacity-80">Features</a>
          <a href="#tokenomics" className="text-base text-white hover:opacity-80">Tokenomics</a>
          <a href="#contact-us" className="text-base text-white hover:opacity-80">Contact Us</a>
        </nav>

        {/* Social Icons */}
  <div className="flex gap-4 items-center max-md:justify-center">
    <a href="https://t.me/BabyUnicornSOL" target="_blank" rel="noopener noreferrer">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/b6d2af109b7c028a21759919d659128dec64a94b"
        alt="Telegram"
        className="w-10 h-10 p-1 rounded border border-pink-300 hover:opacity-80 transition-opacity"
      />
    </a>

    <a href="https://x.com" target="_blank" rel="noopener noreferrer">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/6fa8edb2161dfbd8e6afbb6cc7ececea7de14008"
        alt="Twitter/X"
        className="w-10 h-10 p-1 rounded border border-pink-300 hover:opacity-80 transition-opacity"
      />
    </a>
  </div>

        {/* Copyright */}
        <p className="text-lg text-center text-white max-md:text-base max-sm:text-sm max-sm:leading-snug">
          © 2025 Charlie Baby Unicorn AI 
        </p>
      </div>
    </footer>
  );
}

export default Footer;
